import { Navbar } from './Navbar';
import { MobileNav } from './MobileNav';
import { Footer } from './Footer';
import { BackToTop } from './BackToTop';
import { Toaster } from '../ui/sonner';

export const Layout = ({ children, showFooter = true, showMobileNav = true }) => {
  // Flex column is ONLY needed for sticky-footer sizing (`<main class="flex-1">`
  // pushes Footer to viewport bottom when content is short). When no Footer,
  // we skip the flex layout entirely — natural block flow eliminates iOS
  // Safari's flex-column intrinsic-sizing scroll bug where content can't
  // grow past the parent's min-height:100vh under certain multi-pass layout
  // conditions (checkout page's touch-scroll regression, see index.css:87
  // note on the companion body-scroll fix).
  const useFlex = showFooter;
  return (
    <div className={useFlex ? "min-h-screen flex flex-col" : "min-h-screen"}>
      <Navbar />
      <main
        className={useFlex ? "flex-1" : ""}
        style={{
          // Match Navbar's total rendered height: h-16 (64px) + notch/status
          // bar inset. Without adding the safe-area-inset-top here, page
          // content slides under the notch-aware Navbar on iOS notched devices.
          paddingTop: 'calc(4rem + env(safe-area-inset-top, 0px))',
          // Bottom padding reserves MobileNav clearance (80px) plus the home
          // indicator inset.
          paddingBottom: showMobileNav ? 'calc(80px + env(safe-area-inset-bottom, 0px))' : '0',
        }}
      >
        {children}
      </main>
      {showFooter && <Footer className="hidden md:block" />}
      {showMobileNav && <MobileNav />}
      <BackToTop />
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default Layout;
